import React from "react";
import TreatmentsFAQ from "../../components/faq/faq";

const NinthScreen = () => {
  return <TreatmentsFAQ />;
};

export default NinthScreen;
